import axios from "axios";
import { IResponse } from "./api";
import { timeout } from "components/utils/comm";
import useIsLoadingStore from "store/isLoading";
import useAlertStore from "store/alert";

// type IProps = {
//   formData?: FormData;
//   uploadFiles?: FormData;
//   imgTypCd?: string;
//   lodNo: string;
// };

const baseUrl = `/app/api/common/upload/image`;

const ImgUploadApi = async (formData: FormData) => {
  // const { formData, lodNo } = params;

  const { onSetAlert } = useAlertStore.getState();

  const { showLoading, hideLoading } = useIsLoadingStore.getState();

  const headers: any = {
    "Content-Type": "multipart/form-data; charset=UTF-8",
  };

  // 페이이지 로딩
  showLoading();
  onSetAlert({
    isOpen: false,
    inner: "",
  });

  try {
    axios.defaults.withCredentials = true;
    const response = await axios({
      method: "post",
      url: `${baseUrl}`,
      data: formData,
      headers,
    });

    const res: IResponse = response.data;

    if (response.data?.code === -200) {
      localStorage.removeItem("pages");
      return onSetAlert({
        isOpen: true,
        inner: response.data?.message ?? "",
        onSetConfirm: () => {
          timeout();
        },
      });
    }

    if (res.data?.code !== -200) {
      // useIsLoaing(false);

      const { code, message } = res?.status;

      // api 실패시
      if (code === -1) {
        return onSetAlert({
          isOpen: true,
          inner: message,
          innerHtml: null,
        });
      }
      if (code === 0) {
        return res;
      }
    }
  } catch (error) {
    console.error(error);
  } finally {
    hideLoading();
  }
};

export default ImgUploadApi;
